import { BaseModel } from '@Core';
import { Camera } from './Camera';
import { Threshold } from './ThresholdSetting';
import { GroupPotentialContraventions } from './GroupPotentialContraventions';

export interface CameraNotification extends BaseModel {
    Thresholds?: Threshold[];
    Notes?: string;
    CameraId?: number;
    Camera?: Camera;
    Status?: CameraNotificationStatus;
    Type: CameraNotificationType;
    GroupPotentialContraventionId?: Number;
    GroupPotentialContravention?: GroupPotentialContraventions;
}

export enum CameraNotificationType {
    CameraThreshold,
    Task,
    PhotoOverload,
    PCNsLackingVrn,
    GroupMatching,
    PTZPositionMismatch,
    CameraDisconnected,
    LowCameraPhoto,
    HighCameraPhoto,
    LowCameraBattery,
}

export enum CameraNotificationStatus {
    Unread,
    Read,
}
